import axios from 'axios';
import { getApiErrorMessage } from './apiService';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export interface Permission {
  name: string;
  description: string;
}

export interface Role {
  id: string;
  name: string;
  normalizedName?: string;
  concurrencyStamp?: string;
  permissions: string[];
}

export interface CreateRoleDto {
  name: string;
  permissions: string[];
}

export interface UpdateRoleDto {
  name: string;
  permissions: string[];
}

class RoleService {
  async getAllPermissions(): Promise<Permission[]> {
    try {
      const response = await api.get<Permission[]>('/roles/permissions');
      return response.data;
    } catch (error) {
      console.error('Hiba a jogosultságok lekérdezése során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a jogosultságok lekérdezése során.'));
    }
  }

  async getRoles(): Promise<Role[]> {
    try {
      const response = await api.get<Role[]>('/roles');
      return response.data;
    } catch (error) {
      console.error('Hiba a szerepek lekérdezése során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a szerepek lekérdezése során.'));
    }
  }

  async getRole(id: string): Promise<Role> {
    try {
      const response = await api.get<Role>(`/roles/${id}`);
      return response.data;
    } catch (error) {
      console.error('Hiba a szerepkör lekérdezése során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a szerepkör lekérdezése során.'));
    }
  }

  async createRole(roleData: CreateRoleDto): Promise<Role> {
    try {
      const response = await api.post<Role>('/roles', roleData);
      return response.data;
    } catch (error) {
      console.error('Hiba a szerepkör létrehozása során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a szerepkör létrehozása során.'));
    }
  }

  async updateRole(id: string, roleData: UpdateRoleDto): Promise<void> {
    try {
      await api.put(`/roles/${id}`, roleData);
    } catch (error) {
      console.error('Hiba a szerepkör frissítése során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a szerepkör frissítése során.'));
    }
  }

  async deleteRole(id: string): Promise<void> {
    try {
      await api.delete(`/roles/${id}`);
    } catch (error) {
      console.error('Hiba a szerepkör törlése során:', error);
      throw new Error(getApiErrorMessage(error, 'Hiba a szerepkör törlése során.'));
    }
  }
}

export const roleService = new RoleService();
